export function getFragment(): string {
    return window.location.hash.substr(1);
}